import React from 'react'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { TeamsWithColours } from './RoundResults'
import ResultsBarChart from './charts/ResultsBarChart'
import { percentage, thousandSeparator } from '../model/utils/formatters'
import ChartCard from './components/ChartCard'
import { getYAxisDataV2 } from './charts/yaxis'
import Card from '../../atoms/card/Card'
import Text from '../../atoms/text/Text'
import Icon from '../../atoms/icon/Icon'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'

interface Props {
  currencyDenomination: string
  teams: TeamsWithColours[]
  wholesaleFundingIssues: ModelAPI.Reporting.WholesaleFundingIssuesTeamData[]
}

const TopLabel = (val: any): React.FC => (props: any) => {
  const { x, y, width, value } = props
  if (value == null) {
    return null
  }
  return <g>
    <text x={x + width / 2} y={y - 5} fill="#000" textAnchor="middle" font-weight="bold" font-size='0.8rem'>
      {val}
    </text>
  </g>
}

const RoundResultsCustomerSatisfaction: React.FC<Props> = ({
  currencyDenomination,
  teams,
  wholesaleFundingIssues
}) => {
  const noWholesaleFundingIssues = wholesaleFundingIssues.every(val => val.value === 0)
  const data = wholesaleFundingIssues.map((teamValue) => {
    const team = teams.find(t => t.teamId === teamValue.teamId)
    if (team == null) {
      throw new Error('Team should exist')
    }
    let result: any = {
      name: team.teamName,
      [`team${teamValue.teamId}`]: teamValue.value,
      key: `team${teamValue.teamId}`,
      colour: team.colour,
      topLabel: TopLabel(percentage(teamValue.percentage))
    }
    for (const team of teams) {
      if (!team.isCpuTeam && team.teamId !== teamValue.teamId) {
        result[`team${team.teamId}`] = null
      }
    }
    return result
  })

  const { minValue, maxValue, numberOfTicks } = getYAxisDataV2({
    pastRound1: true,
    min: 0,
    data: [{name: 'fake0', value: 0}].concat(wholesaleFundingIssues.map(wsf => ({ name: 'fakeName', value: wsf.value })))
  })

  return (
    <VerticalGroup full center wide>
      {noWholesaleFundingIssues ? <Card flex wide sharp>
        <VerticalGroup full center wide>
          <VerticalGroup full center wide>
            <Text size="4xl">No Wholesale Funding Issues</Text>
            <InlineGroup block fullHeight center verticalCenter>
              <Icon type='sayno' size={72} />
            </InlineGroup>
          </VerticalGroup>
        </VerticalGroup>
      </Card>:
        <ChartCard heading='Wholesale Funding Issues' currencyDenomination={currencyDenomination}>
          <ResultsBarChart
            data={data}
            teams={teams}
            formatter={(val: number) => thousandSeparator(val)}
            withoutCpuTeams
            minYAxisvalue={minValue}
            maxYAxisvalue={maxValue}
            numberOfTicks={numberOfTicks}
          />
        </ChartCard>
      }
    </VerticalGroup>
  )
}

export default RoundResultsCustomerSatisfaction

